import { render, staticRenderFns } from "./volunteerApply.vue?vue&type=template&id=14ed057c&scoped=true&"
import script from "./volunteerApply.vue?vue&type=script&lang=js&"
export * from "./volunteerApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ed057c",
  null
  
)

export default component.exports